import type { Category, EventId } from "../../../../shared/types";
import type { MobileEditingProps } from "./mobile-calendar-view-types";
import type {
  EventFullData,
  UpdateEventData,
} from "../../../events/types/event-form-types";
import { EditingEventPanel } from "../dialogs/EditingEventPanel";
import { AddEventForm } from "../../../events/components/event-form/AddEventForm";

interface MobileEditPanelProps extends MobileEditingProps {
  readonly activeCategory: Category;
  readonly onDeleteEvent?: (id: EventId) => void;
  readonly onUpdateEvent?: (id: EventId, updates: UpdateEventData) => void;
  readonly onAddEventFull?: (data: EventFullData) => void;
  readonly onAddEvent?: (
    title: string,
    category: Category,
    date: string,
    startTime: string,
    endTime: string,
  ) => void;
  readonly readOnly?: boolean;
}

export function MobileEditPanel({
  editingEvent,
  events,
  showFullEditForm,
  activeCategory,
  onDeleteEvent,
  onUpdateEvent,
  onSetEditingEvent,
  onSetShowFullEditForm,
  onSetPendingResync,
  onSetRecurrenceToast,
  onHandleDuplicate,
  onAddRecurrenceException,
  onUndoEvent,
  onAddEventFull,
  onAddEvent,
  readOnly,
}: MobileEditPanelProps) {
  if (!editingEvent) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/40"
        onClick={() => onSetEditingEvent(null)}
      />
      <div className="fixed inset-0 z-50 bg-surface overflow-y-auto scrollbar-custom flex flex-col pb-[env(safe-area-inset-bottom)]">
        {showFullEditForm && !readOnly && onAddEvent ? (
          <AddEventForm
            eventToEdit={editingEvent}
            defaultCategory={activeCategory}
            defaultDate={editingEvent.date}
            onAdd={onAddEvent}
            onUpdateEvent={onUpdateEvent}
            onClose={() => {
              onSetShowFullEditForm(false);
              onSetEditingEvent(null);
            }}
          />
        ) : (
          <div className="p-4 pb-6">
            <EditingEventPanel
              editingEvent={editingEvent}
              events={events}
              onDeleteEvent={readOnly ? undefined : onDeleteEvent}
              onUpdateEvent={readOnly ? undefined : onUpdateEvent}
              onSetEditingEvent={onSetEditingEvent}
              onSetShowFullEditForm={readOnly ? undefined : onSetShowFullEditForm}
              onSetPendingResync={onSetPendingResync}
              onSetRecurrenceToast={onSetRecurrenceToast}
              onDuplicate={readOnly ? undefined : onHandleDuplicate}
              onAddRecurrenceException={readOnly ? undefined : onAddRecurrenceException}
              onUndoEvent={readOnly ? undefined : onUndoEvent}
              onAddEventFull={readOnly ? undefined : onAddEventFull}
              readOnly={readOnly}
            />
          </div>
        )}
      </div>
    </>
  );
}
